import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import SearchBar from "../common/SearchBar";
import "./NewNavbar.css"; // Import the custom CSS for hover functionality
import BrandLogo from "../assets/img/spelllogodark.png";
import AbcIcon from "@mui/icons-material/Abc";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { usePreference } from "../context/UserContext";
import {
  ArticleRounded,
  ClassRounded,
  ListOutlined,
  ScoreboardOutlined,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { FaBook, FaChartBar, FaEnvelope, FaWhatsapp } from "react-icons/fa";
import NavbarTop from "./navbar/NavbarTop";
import {
  Dialog,
  DialogContent,
  IconButton,
  ListItemIcon,
  Tooltip,
} from "@mui/material";
import NewScreen from "./statistics/NewScreen";
import IMG from "../assets/img/spellinglogo.png";
import UserProfile from "./EditProfile/UserProfile";
import ProfilePopup from "./EditProfile/ProfilePopup";
import ImageSlider from "./statistics/ImageSlider";
import { useNavigate } from "react-router-dom";
import PopupForm from "./signup/ContactForm";

const NewNavbar = ({ setShowModal }) => {
  const {
    isNavVisible,
    isLogged,
    updateIsLoginOpen,
    updateIsLogged,
    updateIsSignUpOpen,
    upateForgotPwdOpen,
    showCart,
    updateShowCart,
    cart,
    updateCart,
    profilePhoto,
    updateProfilePhoto,
  } = usePreference();

  const [username, setUsername] = useState("");
  const navigate = useNavigate();

  const [openSlider, setopenSlider] = useState(false);
  const [open, setOpen] = useState(false);
  const [userRole, setUserRole] = useState("");
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(true);
  const [isAdminMenuOpen, setIsAdminMenuOpen] = useState(true);
  const sidebarRef = useRef(null); // Ref for the sidebar
  const [opengraph, setOpengraph] = useState(false);
  const [openContactForm, setContactForm] = useState(false);

  useEffect(() => {
    const loggedin = localStorage.getItem("loggedin");
    updateIsLogged(loggedin);

    const storedUsername = localStorage.getItem("username") || "User";
    const storedUserRole = localStorage.getItem("userrole") || "User";
    const storedProfilePhoto = localStorage.getItem("userphoto");

    const profilePhotoURL =
      storedProfilePhoto && storedProfilePhoto !== "null"
        ? `https://s3nsoftware.com/profilepics/${storedProfilePhoto}.jpg`
        : "";

    setUsername(storedUsername);
    setUserRole(storedUserRole);
    updateProfilePhoto(profilePhotoURL);
  }, [isLogged, updateIsLogged, profilePhoto]);

  useEffect(() => {
    // Close sidebar if clicked outside of it
    const handleClickOutside = (event) => {
      if (
        isMobileNavOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setMobileNavOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileNavOpen]);

  const handleLogin = () => {
    updateIsLoginOpen(true);
  };

  const handleSign = () => {
    updateIsSignUpOpen(true);
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once signed out, you will need to log in again.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, sign me out!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Signed Out!",
          text: "You have been signed out successfully.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });

        updateIsLogged(false);
        localStorage.clear();
        window.location.href = "/";
      } else {
        Swal.fire({
          title: "You are still signed in!",
          icon: "info",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    });
  };
  const handleWordpacks = (e) => {
    e.preventDefault();
    navigate("/#alldata");
  };
  const handleSlider = (e) => {
    e.preventDefault();
    navigate("/#slider");
  };

  const handleForgot = () => {
    updateIsLoginOpen(false);
    upateForgotPwdOpen(true);
    updateIsSignUpOpen(false);
    setMobileNavOpen(!isMobileNavOpen);
  };

  const handleWordsTable = () => {
    // any extra logic here
    navigate("/searchwords");
  };

  const handleLearnPage = () => {
    navigate("/learn");
  };

  const handleMyQuizzes = () => {
    navigate("/myquizzes");
  };

  const toggleMobileNav = () => {
    setMobileNavOpen(!isMobileNavOpen);
  };

  const toggleAccountMenu = () => {
    setIsAccountMenuOpen(!isAccountMenuOpen);
  };

  const toggleAdminMenu = () => {
    setIsAdminMenuOpen(!isAdminMenuOpen);
  };

  return isNavVisible ? (
    <>
      <NavbarTop />
      <nav className="navbar navbar-expand-md" id="top">
        <div className="container">
          {/* <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src={BrandLogo}
              alt="Brand Logo"
              style={{ width: "80px", height: "50px" }}
            />
          </a> */}

          <div className="search-bar-section">
            <SearchBar />
          </div>
          {/* <img
            src={IMG}
            alt="Logo"
            style={{
              width: "100px",
              height: "100px",
              zIndex: 10,
              position: "absolute",
              left: "50%",
              top: "100%",
              transform: "translate(-50%, -50%)",
              display: window.innerWidth <= 600 ? "none" : "hidden",
            }}
          /> */}

          <button
            className="navbar-toggler"
            type="button"
            aria-label="Toggle navigation"
            onClick={toggleMobileNav}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Mobile Sidebar */}
          <div
            className={`mobile-nav ${isMobileNavOpen ? "open" : ""}`}
            ref={sidebarRef} // Sidebar ref for click detection
          >
            <button className="close-btn" onClick={toggleMobileNav}>
              &times;
            </button>

            <div className="sidebar-content">
              {/* Cart Icon in Mobile View */}
              {cart && cart.length > 0 && (
                <div
                  className="mobile-cart-icon"
                  style={{ marginTop: "20px", textAlign: "center" }}
                >
                  <button
                    className="dropdown-item"
                    style={{ position: "relative" }} // Set relative positioning for the button
                    onClick={() => updateShowCart(true)}
                  >
                    <ShoppingCartOutlined
                      style={{ color: "black", fontSize: "32px" }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        top: "-5px",

                        backgroundColor: "red",
                        color: "white",
                        borderRadius: "50%",
                        padding: "1px 6px",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      {cart.length}
                    </span>
                  </button>
                </div>
              )}
              {/* Profile Section */}
              {isLogged === "true" && (
                <div className="profile-section">
                  <img
                    src={profilePhoto || "https://picsum.photos/200"}
                    alt="Profile"
                    className="rounded-circle"
                    width="50"
                    height="50"
                  />
                  {/* <p className="username">{username}</p> */}

                  <div
                    className="username-dropdown"
                    onClick={toggleAccountMenu}
                  >
                    <span>
                      <p className="username">{username}</p>
                    </span>
                    <i
                      className={`dropdown-icon ${
                        isAccountMenuOpen ? "open" : ""
                      }`}
                    ></i>
                  </div>

                  {isAccountMenuOpen && (
                    <div className="account-settings">
                      <ul className="nav-list">
                        <li>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={() => setOpen(true)}
                          >
                            Profile
                          </a>
                          {open && (
                            <ProfilePopup
                              open={open}
                              onClose={() => setOpen(false)}
                            />
                          )}
                        </li>

                        <li>
                          <a href="#" onClick={handleForgot}>
                            Change Password
                          </a>
                        </li>
                        <li>
                          <a href="#" onClick={handleLogout}>
                            Logout
                          </a>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              )}

              {/* Admin Section */}
              {(userRole === "Admin" || userRole === "SuperAdmin") && (
                <div className="admin-section ">
                  <div className="username-dropdown " onClick={toggleAdminMenu}>
                    <span>Admin</span>
                    <i
                      className={`dropdown-icon ${
                        isAdminMenuOpen ? "open" : ""
                      }`}
                    ></i>
                  </div>

                  {isAdminMenuOpen && (
                    <div className="admin-menu">
                      <ul className="nav-list">
                        {/* <li>
                          <a onClick={(e) => handleWordpacks(e)}>Word packs</a>
                        </li> */}
                        <li>
                          <a href="/admin">Admin Panel</a>
                        </li>
                        <li>
                          <a href="/feedbacks">Manage Feedbacks</a>
                        </li>
                        <li>
                          <a
                            className="btn btn-secondary ms-md-2"
                            role="button"
                            href="#"
                            onClick={() => setContactForm(true)}
                          >
                            ContactForm
                          </a>
                          <PopupForm
                            isOpen={openContactForm}
                            onClose={() => setContactForm(false)}
                          />
                        </li>
                        <li>
                          <a href="/wordsdata">Add Words</a>
                        </li>
                        <li>
                          <a
                            // className="dropdown-item"
                            // style={{ cursor: "pointer" }}
                            onClick={handleWordsTable}
                          >
                            Word Explorer
                          </a>
                        </li>
                        <li>
                          <a
                            // className="dropdown-item"
                            // style={{ cursor: "pointer" }}
                            onClick={handleLearnPage}
                          >
                            Learn
                          </a>
                        </li>
                        {/* <li>
                          <a
                            // className="dropdown-item"
                            // style={{ cursor: "pointer" }}
                            onClick={handleMyQuizzes}
                          >
                            My Quizzes
                          </a>
                        </li> */}
                      </ul>
                    </div>
                  )}
                </div>
              )}
              <Dialog
                open={opengraph}
                onClose={() => setOpengraph(false)}
                fullWidth
                maxWidth="lg"
              >
                <IconButton
                  onClick={() => setOpengraph(false)}
                  style={{ position: "absolute", right: 10, top: 10 }}
                >
                  <CloseIcon />
                </IconButton>
                <DialogContent>
                  <NewScreen user={username} />
                </DialogContent>
              </Dialog>
              {isLogged === "true" && userRole === "User" && (
                <>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={() => setOpengraph(true)}
                    >
                      <Tooltip title="Analyze Your Performance" arrow>
                        <FaChartBar /> Analyze your Performance
                      </Tooltip>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={() => setShowModal(true)}
                    >
                      Feedback
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      onClick={(e) => handleWordpacks(e)}
                      // className="btn btn-secondary ms-md-2"
                      role="button"
                      href="#"
                      // style={{
                      //   background: "yellow",
                      //   color: "black",
                      //   padding: "10px",
                      //   borderRadius: "5px",
                      //   fontSize: "16px",
                      //   border: "none",
                      //   cursor: "pointer",
                      //   textDecoration: "none",
                      // }}
                    >
                      Word Packs
                    </a>
                  </li>
                </>
              )}

              {/* Feedback Section */}
              {/* {isLogged === "true" && userRole === "User" && (
                <div className="feedback-section text-center">
                  <a
                    href="#"
                    onClick={() => {
                      toggleMobileNav();
                      setShowModal(true);
                    }}
                  >
                    Feedback
                  </a>
                </div>
              )} */}

              {/* Login for non-logged users */}
              {isLogged !== "true" && (
                <div className="login-section">
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      toggleMobileNav();
                      handleLogin();
                    }}
                  >
                    Login
                  </button>

                  <a
                    className="btn btn-secondary ms-md-2"
                    role="button"
                    href="#"
                    onClick={() => setContactForm(true)}
                  >
                    ContactForm
                  </a>
                  <PopupForm
                    isOpen={openContactForm}
                    onClose={() => setContactForm(false)}
                  />

                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      toggleMobileNav();
                      handleSign();
                    }}
                  >
                    SignUp
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto align-items-center text-center ">
              <li>
                <a
                  className="nav-link"
                  href="#"
                  onClick={(e) => handleSlider(e)}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <AbcIcon
                      style={{
                        backgroundColor: "black",
                        borderRadius: "50px",
                        padding: "8px",
                        fontSize: "40px",
                      }}
                    />
                    <span
                      style={{
                        fontSize: "14px",
                        // fontWeight: "bold",
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                      Word of the Day
                    </span>
                  </div>
                </a>
                {/* {openSlider && (
                  <ImageSlider onClose={() => setopenSlider(false)} />
                )} */}
              </li>

              {/* Admin Section */}
              {(userRole === "Admin" || userRole === "SuperAdmin") && (
                <>
                  {/* <li>
                    <a className="nav-link" href="/myquizzes">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <ArticleRounded
                          style={{
                            backgroundColor: "#FFC300",
                            borderRadius: "50px",
                            padding: "8px",
                            fontSize: "40px",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "14px",
                            // fontWeight: "bold",
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          My Quizzes
                        </span>
                      </div>
                    </a>
                  </li> */}

                  {/* <li>
                    <a
                      className="nav-link"
                      href="#"
                      onClick={(e) => handleWordpacks(e)}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <ListOutlined
                          style={{
                            backgroundColor: "#FF5733",
                            borderRadius: "50px",
                            padding: "8px",
                            fontSize: "40px",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "14px",
                            // fontWeight: "bold",
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          Word Packs
                        </span>
                      </div>
                    </a>
                  </li> */}

                  {/* <li>
                    <a
                      className="nav-link"
                      href="/learn"
                      // onClick={() => setOpengraph(true)}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <ClassRounded
                          style={{
                            backgroundColor: "yellowgreen",
                            borderRadius: "40px",
                            padding: "3px",
                            fontSize: "40px",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "14px",
                            // fontWeight: "bold",
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          Learn
                        </span>
                      </div>
                    </a>
                  </li> */}

                  <li className="nav-item dropdown profile-dropdown text-center">
                    <a
                      className="nav-link dropdown-toggle d-flex align-items-center "
                      href="#"
                      id="adminDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Admin
                    </a>

                    <ul
                      className="dropdown-menu dropdown-menu-end"
                      aria-labelledby="adminDropdown"
                    >
                      <li>
                        <a className="dropdown-item" href="/admin">
                          Admin Panel
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/feedbacks">
                          Manage Feedbacks
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="/users">
                          Users
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={() => setOpengraph(true)}
                        >
                          Statistics
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="/wordsdata"
                          // onClick={() => setOpengraph(true)}
                        >
                          Add Words
                        </a>
                      </li>
                    </ul>
                  </li>
                </>
              )}
              {/* User Feedback */}
              {isLogged === "true" && userRole === "User" && (
                <>
                  <Dialog
                    open={opengraph}
                    onClose={() => setOpengraph(false)}
                    fullWidth
                    maxWidth="lg"
                  >
                    <IconButton
                      onClick={() => setOpengraph(false)}
                      style={{ position: "absolute", right: 10, top: 10 }}
                    >
                      <CloseIcon />
                    </IconButton>
                    <DialogContent>
                      <NewScreen user={username} />
                    </DialogContent>
                  </Dialog>
                  {/* <li>
                    <a className="nav-link" href="/myquizzes">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <ArticleRounded
                          style={{
                            backgroundColor: "#FFC300",
                            borderRadius: "50px",
                            padding: "8px",
                            fontSize: "40px",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "14px",
                            // fontWeight: "bold",
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          My Quizzes
                        </span>
                      </div>
                    </a>
                  </li> */}

                  {/* <li>
                    <a className="nav-link" onClick={(e) => handleWordpacks(e)}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <ListOutlined
                          style={{
                            backgroundColor: "#FF5733",
                            borderRadius: "50px",
                            padding: "8px",
                            fontSize: "40px",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "14px",
                            // fontWeight: "bold",
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          Word Packs
                        </span>
                      </div>
                    </a>
                  </li> */}
                  {/* <li>
                    <a
                      className="nav-link"
                      href="/learn"
                      // onClick={() => setOpengraph(true)}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <ClassRounded
                          style={{
                            backgroundColor: "yellowgreen",
                            borderRadius: "40px",
                            padding: "3px",
                            fontSize: "40px",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "14px",
                            // fontWeight: "bold",
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          Learn
                        </span>
                      </div>
                    </a>
                  </li> */}

                  {/* <li>
                    <a
                      className="nav-link"
                      href="#"
                      onClick={() => setOpengraph(true)}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaChartBar
                          style={{
                            backgroundColor: "yellowgreen",
                            borderRadius: "50px",
                            padding: "8px",
                            fontSize: "40px",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "14px",
                            // fontWeight: "bold",
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          Statistics
                        </span>
                      </div>
                    </a>
                  </li> */}
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={() => setShowModal(true)}
                    >
                      Feedback
                    </a>
                  </li>
                  <li className="nav-link">
                    <a
                      className="btn btn-secondary ms-md-2"
                      role="button"
                      href="#"
                      onClick={() => setContactForm(true)}
                    >
                      ContactForm
                    </a>
                    <PopupForm
                      isOpen={openContactForm}
                      onClose={() => setContactForm(false)}
                    />
                  </li>
                </>
              )}

              {isLogged === "true" && (
                <li className="nav-item dropdown profile-dropdown">
                  <a
                    className="nav-link dropdown-toggle d-flex align-items-center"
                    href="#"
                    id="profileDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src={
                        profilePhoto && profilePhoto.trim() !== ""
                          ? profilePhoto
                          : "https://picsum.photos/200"
                      }
                      alt="Profile"
                      className="rounded-circle me-2"
                      width="40"
                      height="40"
                    />
                    {username}
                  </a>
                  <ul
                    className="dropdown-menu dropdown-menu-end"
                    aria-labelledby="profileDropdown"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() => setOpen(true)}
                      >
                        Profile
                      </a>
                      {open && (
                        <ProfilePopup
                          open={open}
                          onClose={() => setOpen(false)}
                        />
                      )}
                    </li>
                    {/* <li>
                      <a className="dropdown-item" href="/myquizzes">
                        My Quizzes
                      </a>
                    </li> */}
                    {/* <li>
                      <a
                        className="dropdown-item"
                        style={{ cursor: "pointer" }}
                        onClick={handleWordsTable}
                      >
                        Word Explorer
                      </a>
                    </li> */}
                    <li>
                      <a
                        className="dropdown-item"
                        style={{ cursor: "pointer" }}
                        onClick={handleForgot}
                      >
                        Change Password
                      </a>
                    </li>
                    <li>
                      <button className="dropdown-item" onClick={handleLogout}>
                        Logout
                      </button>
                    </li>
                  </ul>
                </li>
              )}

              {isLogged !== "true" && (
                <li className="nav-item">
                  <>
                    {/* <a
                      className="btn btn-secondary ms-md-2"
                      role="button"
                      href="#alldata"
                      // style={{background:'linear-gradient(to bottom,rgb(151, 8, 151), #d8bfd8)'}}
                    >
                      Word Packs
                    </a> */}
                    <a
                      className="btn btn-secondary ms-md-2"
                      role="button"
                      href="#"
                      onClick={handleLogin}
                    >
                      Login
                    </a>
                    <a
                      className="btn btn-secondary ms-md-2"
                      role="button"
                      href="#"
                      onClick={() => setContactForm(true)}
                    >
                      ContactForm
                    </a>
                    <PopupForm
                      isOpen={openContactForm}
                      onClose={() => setContactForm(false)}
                    />
                    <a
                      className="btn btn-secondary ms-md-2"
                      role="button"
                      href="#"
                      onClick={handleSign}
                    >
                      SignUp
                    </a>
                  </>
                </li>
              )}

              {cart && cart.length > 0 ? (
                <li>
                  <button
                    className="dropdown-item"
                    style={{ position: "relative" }} // Set relative positioning for the button
                    onClick={() => updateShowCart(true)}
                  >
                    <ShoppingCartOutlined
                      style={{ color: "white", fontSize: "32px" }}
                    />

                    {/* Cart length indicator */}
                    <span
                      style={{
                        position: "absolute",
                        top: "-5px", // Adjust the positioning relative to the ShoppingCart icon
                        right: "-5px",
                        backgroundColor: "red",
                        color: "white",
                        borderRadius: "50%",
                        padding: "1px 6px",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      {cart.length}
                    </span>
                  </button>
                </li>
              ) : (
                <></>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  ) : null;
};

export default NewNavbar;
